import React from 'react';

const AuthLayout = React.lazy(
  async () => await import('@/pages/Auth/Layout/AuthLayout'),
);
const Login = React.lazy(async () => await import('@/pages/Auth/Login/Login'));
const LoginByPhoneNo = React.lazy(
  async () => await import('@/pages/Auth/LoginByPhoneNo'),
);
const SMSVerify = React.lazy(
  async () => await import('@/pages/Auth/SMSVerify/SMSVerify'),
);
const Signup = React.lazy(
  async () => await import('@/pages/Auth/Signup/Signup'),
);
const CompleteRegistragion = React.lazy(
  async () =>
    await import('@/pages/Auth/CompleteRegistragion/CompleteRegistragion'),
);
const ForgetPassword = React.lazy(
  async () => await import('@/pages/Auth/ForgetPassword/ForgetPassword'),
);
const ChangePassword = React.lazy(
  async () => await import('@/pages/Auth/ChangePassword/ChangePassword'),
);

export {
  AuthLayout,
  Login,
  LoginByPhoneNo,
  Signup,
  SMSVerify,
  CompleteRegistragion,
  ForgetPassword,
  ChangePassword,
};
